export default function ecDateFormat() {
  return {
    require: '^ngModel',
    restrict: 'A',
    link: function(scope, elm, attrs, ctrl) {
      var dateFormat = attrs.ecDateFormat,
        modelMomentBackup;

      ctrl.$formatters.unshift(function(modelValue) {
        if (!dateFormat || !modelValue) {
          return '';
        }
        modelValue = new Date(modelValue);
        modelMomentBackup = moment(modelValue);

        return moment(modelValue).format(dateFormat);
      });

      ctrl.$parsers.unshift(function(viewValue) {
        var date = moment(viewValue, dateFormat);
        date.date(modelMomentBackup.date());

        return date && date.isValid() ? date : '';
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/common/dateFormat.directive.js